import { MapPage } from './ui/pages/mapPage.js'
import { analytics } from './analytics/analytics.js'
import { PrivacyIndicator } from './ui/components/privacyIndicator.js'

const initApp = async () => {
  const app = document.getElementById('app')

  if (!app) {
    console.error('App container not found')
    return
  }

  analytics.setConsent(true)

  const mapPage = new MapPage('app')
  await mapPage.init()

  const privacyIndicator = new PrivacyIndicator()
  privacyIndicator.render(document.body)
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApp)
} else {
  initApp()
}
